export default ({ tooltip = null, tooltipCopied = null, timeout = 2000, init, ...props }) => {
    return {
        ...props,
        copied: false,
        copy(value) {
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, timeout);

            void navigator.clipboard.writeText(value); // require https
        },
        tooltip: {
            ["x-tooltip"]() {
                return {
                    content: this.copied ? tooltipCopied : tooltip,
                    hideOnClick: false,
                };
            },
        },
        init() {
            init?.bind(this)();
        },
    };
};
